var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAckBgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1182,
    height: 547,
    viewBox: "0 0 1182 547",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1182,
    height: 546.569,
    rx: 16,
    fill: "#fff7e3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1182 224.5C1128.92 335.652 967.939 439.031 586.535 357.392C250.547 285.473 38.3594 446.518 0 546V432C52.6406 295.482 214.654 175.525 607.466 259.607C954.862 333.967 1153.42 180.349 1182 120.5V224.5Z",
    fill: "#ffecc7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAckBgImg);
export default __webpack_public_path__ + "static/media/ackBgImg.4217ba683b17de73c504c7c214fae7f5.svg";
export { ForwardRef as ReactComponent };